import clsx from 'clsx'
import { useState } from 'react'
import { Link } from 'react-router-dom'

// Style
import './style.scss'

import { useAppSelector } from 'shared/hooks'
import { Button } from 'shared/ui'

import arrowBackIcon from '../../../assets/image/icons/svg/icons/arrow-back.svg'
import timeBackIcon from '../../../assets/image/icons/svg/icons/time-back.svg'
import messageIcon from '../../../assets/image/icons/tables/message.svg'
import { CONSTS } from '../../../config/objectConst'
// Component
import DescriptionList from '../../molecules/descriptionList'
import Chart from '../chart'
import { chartModel } from '../chart/chartModel'
import css from './DescriptionSegment.module.scss'

const getMessageTitle = (action: any) => {
	switch (action.type) {
		case CONSTS.AVAILABLE_ACTIONS.Message.Type:
			return 'Message:'

		case CONSTS.AVAILABLE_ACTIONS.Connect.Type: {
			if (action.values.textarea !== '') {
				return 'Note message:'
			}
		}
	}

	return ''
}

type Action = any & {
	type: string
}

const isMessageFullAction = ({ type }: Action) =>
	type === CONSTS.AVAILABLE_ACTIONS.Connect.Type ||
	type === CONSTS.AVAILABLE_ACTIONS.Message.Type

const Segment = (action: any) => (
	<div className={css.segment}>
		<DescriptionList
			className={css.description}
			label={getMessageTitle(action)}
		>
			{action.values.textarea === '' && isMessageFullAction(action) ? (
				<div className='d-segment-body-description__empty'>
					<img
						alt='message-icon'
						className='d-segment-body-description__empty-icon'
						src={messageIcon}
					/>
					<p>Your note message is empty</p>
				</div>
			) : (
				action.values.textarea
			)}
		</DescriptionList>
		<div className={css.chart}>
			{action.statistics && (
				<Chart
					statistics={chartModel.personalizeActionStatistics(action)}
					title={'Action Statistics:'}
				/>
			)}
		</div>
	</div>
)

export function DescriptionSegment() {
	const [showIndex, setShowIndex] = useState(0)

	const actions = useAppSelector(state => state.campaign.actions)
	const allowEditSteps = useAppSelector(state => state.campaign.allowEditSteps)
	const id = useAppSelector(state => state.campaign.id)

	const currentAction = actions[showIndex]
	return (
		<>
			<div className='d-segment-tabs'>
				<div className={clsx(css.tabs, 'app-scroll-thin')}>
					{actions.map((action: any, index: number) => (
						<Tab
							isActive={showIndex === index}
							key={action.id}
							{...action}
							onClick={() => setShowIndex(index)}
						/>
					))}
				</div>
				{allowEditSteps && Boolean(actions.length) && (
					<Button
						as={Link}
						className={css.edit}
						to={`/campaigns/${id}/tune`}
						variant='bordered-dark'
					>
						Edit
					</Button>
				)}
			</div>

			{currentAction && (
				<div className='d-segment actions active'>
					<Segment {...currentAction} key={currentAction.id} />
				</div>
			)}
		</>
	)
}

function checkUnit(minutes: number, border: number, unit: string) {
	if (minutes < border) {
		return ''
	}

	const inUnit = minutes / border
	if (minutes % border) {
		return `${Math.floor(inUnit)}+ ${unit}`
	}

	return `${inUnit} ${unit}`
}

function showPeriod(minutes: number) {
	let result =
		checkUnit(minutes, 1440, 'days') || checkUnit(minutes, 60, 'hours')

	result ||= minutes > 0 ? `${minutes} min` : 'no delay'

	return result
}

function Tab({
	isActive,
	name,
	onClick,
	type,
	values
}: Action & { isActive: boolean; onClick: () => void }) {
	const isConnect = type === CONSTS.AVAILABLE_ACTIONS.Connect.Type
	return (
		<div className={clsx(css.tab, isActive && css.tabActive)} onClick={onClick}>
			<span className={clsx(css.count, 'no-wrap')}> {name}</span>
			{values.period < CONSTS.DELAY_TIMEOUT && (
				<>
					<span className='d-segment-tabs__dot' />
					<img
						alt={isConnect ? 'arrow back icon' : 'time back icon'}
						className='d-segment-tabs__icon'
						src={isConnect ? arrowBackIcon : timeBackIcon}
					/>{' '}
					<span className='no-wrap'>{showPeriod(values.period)}</span>
				</>
			)}
		</div>
	)
}
